import classNames from 'classnames';
import React from 'react';

type Props = {
  children?: React.ReactNode,
  useAlternateColor?: boolean,
  className?: string
};

class Row extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      children,
      useAlternateColor,
      className
    } = this.props;

    return (
      <div className={classNames('row esko_row', {esko_rowalternatecolor: useAlternateColor}, className)}>
        {children}
      </div>
    );
  }
}

export default Row;
